export const axios = require("../lib/axios");

export const CRUD = {
  create: async (url, data) => await axios.post(url, { ...data }),
  findOne: async (url, id, params = "") =>
    await axios.get(`${url}/${id}${params}`),
  find: async url => await axios.get(url),
  update: async (url, id, update) =>
    await axios.put(`${url}` + (id ? `/${id}` : ""), { ...update }),
  disable: async (url, id) =>
    await axios.patch(`${url}` + (id ? `/${id}` : "")),
  delete: async (url, id) =>
    await axios._delete(`${url}` + (id ? `/${id}` : ""))
};
